/* eslint-disable no-dupe-else-if */
import React from "react";
import { CustomChip } from "../CustomChip";
import { capitalizeWords } from "../../helpers";

interface IActiveInActiveStatusProps {
  status: string;
  size?: "small" | "medium";
}

export const StatusRenderer: React.FC<IActiveInActiveStatusProps> = (props) => {
  const status = (props.status || "").toLowerCase();
  const size = props.size || "small";
  if (status === "active") {
    return <CustomChip color="success" content={"Active"} size={size} />;
  } else if (status === "new") {
    return <CustomChip color="success" content={"New"} size={size} />;
  } else if (status === "open") {
    return <CustomChip color="success" content={"Open"} size={size} />;
  } else if (status === "closed") {
    return <CustomChip color="error" content={"Closed"} size={size} />;
  } else if (status === "re-opened") {
    return <CustomChip color="info" content={"Re-Opened"} size={size} />;
  } else if (status === "inactive") {
    return <CustomChip color="error" content={"Inactive"} size={size} />;
  } else if (status === "new submission") {
    return (
      <CustomChip color="success" content={"New Submission"} size={size} />
    );
  } else if (status === "quote received") {
    return (
      <CustomChip
        color="warning"
        content={"Quote Received"}
        sx={{ color: "#000" }}
        size={size}
      />
    );
  } else if (status === "remote work") {
    return <CustomChip color="secondary" content={"Remote Work"} size={size} />;
  } else if (status === "on-leave") {
    return <CustomChip color="info" content={"On-Leave"} size="small" />;
  } else if (status === "completed") {
    return <CustomChip color="success" content={"Completed"} size="small" />;
  } else if (status === "pending") {
    return <CustomChip color="error" content={"Pending"} size="small" />;
  } else if (status === "opened") {
    return <CustomChip color="success" content={"Opened"} size="small" />;
  } else if (status === "closed") {
    return <CustomChip color="error" content={"Closed"} size="small" />;
  } else if (status === "cancelled") {
    return <CustomChip color="error" content={"Cancelled"} size="small" />;
  } else if (status === "pending_for_signature") {
    return (
      <CustomChip
        color="warning"
        content={"Pending for signature"}
        sx={{ color: "#000" }}
        size="small"
      />
    );
  } else if (status === "overdue") {
    return <CustomChip color="error" content={"Overdue"} size="small" />;
  } else if (status === "completed") {
    return <CustomChip color="success" content={"Completed"} size="small" />;
  } else if (status === "pending") {
    return <CustomChip color="warning" content={"Pending"} size="small" />;
  } else if (status === "opened") {
    return <CustomChip color="success" content={"Opened"} size="small" />;
  } else if (status === "closed") {
    return <CustomChip color="error" content={"Closed"} size="small" />;
  } else if (status === "pending_for_signature") {
    return (
      <CustomChip
        color="warning"
        content={"Pending for signature"}
        sx={{ color: "#000" }}
        size="small"
      />
    );
  } else if (status === "overdue") {
    return <CustomChip color="error" content={"Overdue"} size="small" />;
  } else if (status === "completed") {
    return <CustomChip color="success" content={"Completed"} size="small" />;
  } else if (status === "pending") {
    return <CustomChip color="warning" content={"Pending"} size="small" />;
  } else if (status === "opened") {
    return <CustomChip color="success" content={"Opened"} size="small" />;
  } else if (status === "closed") {
    return <CustomChip color="error" content={"Closed"} size="small" />;
  } else if (status === "pending_for_signature") {
    return (
      <CustomChip
        color="warning"
        content={"Pending for signature"}
        sx={{ color: "#000" }}
        size="small"
      />
    );
  } else if (status === "overdue") {
    return <CustomChip color="error" content={"Overdue"} size="small" />;
  } else if (status === "completed") {
    return <CustomChip color="success" content={"Completed"} size="small" />;
  } else if (status === "OPPORTUNITY") {
    return <CustomChip color="warning" content={"OPPORTUNITY"} size="small" />;
  } else if (status === "CLOSED ONE") {
    return <CustomChip color="success" content={"CLOSED ONE"} size="small" />;
  } else if (status === "pending") {
    return <CustomChip color="warning" content={"Pending"} size="small" />;
  } else if (status === "opened") {
    return <CustomChip color="success" content={"Opened"} size="small" />;
  } else if (status === "closed") {
    return <CustomChip color="error" content={"Closed"} size="small" />;
  } else if (status === "pending_for_signature") {
    return (
      <CustomChip
        color="warning"
        content={"Pending for signature"}
        sx={{ color: "#000" }}
        size="small"
      />
    );
  } else if (status === "overdue") {
    return <CustomChip color="error" content={"Overdue"} size="small" />;
  } else if (status === "completed") {
    return <CustomChip color="success" content={"Completed"} size="small" />;
  } else if (status === "pending") {
    return <CustomChip color="warning" content={"Pending"} size="small" />;
  } else if (status === "opened") {
    return <CustomChip color="success" content={"Opened"} size="small" />;
  } else if (status === "closed") {
    return <CustomChip color="error" content={"Closed"} size="small" />;
  } else if (status === "completed") {
    return <CustomChip color="success" content={"Completed"} size={size} />;
  } else if (status === "pending") {
    return <CustomChip color="warning" content={"Pending"} size={size} />;
  } else if (status === "opened") {
    return <CustomChip color="success" content={"Opened"} size={size} />;
  } else if (status === "closed") {
    return <CustomChip color="error" content={"Closed"} size={size} />;
  } else if (status === "pending_for_signature") {
    return (
      <CustomChip
        color="warning"
        content={"Pending for signature"}
        sx={{ color: "#000" }}
        size={size}
      />
    );
  } else if (status === "overdue") {
    return <CustomChip color="error" content={"Overdue"} size={size} />;
  } else if (status === "spare") {
    return <CustomChip color="success" content={"Spare"} size={size} />;
  } else if (status === "assigned") {
    return <CustomChip color="primary" content={"Assigned"} size={size} />;
  } else if (status === "adjuster assigned") {
    return (
      <CustomChip
        color="info"
        content={"Adjuster Assigned"}
        sx={{ color: "#fff" }}
        size={size}
      />
    );
  } else if (status === "insurer reported") {
    return (
      <CustomChip
        color="warning"
        content={"Insurer Reported"}
        sx={{ color: "#000" }}
        size={size}
      />
    );
  } else if (status === "discarded") {
    return <CustomChip color="error" content={"Discarded"} size={size} />;
  } else if (status === "draft") {
    return (
      <CustomChip
        color="warning"
        sx={{ color: "#000" }}
        content={"Draft"}
        size={size}
      />
    );
  } else if (status === "paid") {
    return <CustomChip color="success" content={"Paid"} size={size} />;
  } else if (status === "unpaid") {
    return <CustomChip color="error" content={"Unpaid"} size={size} />;
  } else if (status === "partially paid") {
    return (
      <CustomChip color="primary" content={"Partially Paid"} size={size} />
    );
  } else if (status === "application recieved") {
    return (
      <CustomChip
        color="default"
        content={"Application Received"}
        sx={{ backgroundColor: "#2196F3", color: "#FFF" }}
        size="small"
      />
    );
  } else if (status === "application reviewed") {
    return (
      <CustomChip
        color="default"
        content={"Application Reviewed"}
        sx={{ backgroundColor: "#4CAF50", color: "#FFF" }}
        size="small"
      />
    );
  } else if (status === "application rejected") {
    return (
      <CustomChip
        color="default"
        content={"Application Rejected"}
        sx={{ backgroundColor: "#F44336", color: "#FFF" }}
        size="small"
      />
    );
  } else if (status === "initial interview") {
    return (
      <CustomChip
        color="default"
        content={"Initial Interview"}
        sx={{ backgroundColor: "#FF9800", color: "#000" }}
        size="small"
      />
    );
  } else if (status === "final interview") {
    return (
      <CustomChip
        color="default"
        content={"Final Interview"}
        sx={{ backgroundColor: "#FFC107", color: "#000" }}
        size="small"
      />
    );
  } else if (status === "job offer") {
    return (
      <CustomChip
        color="default"
        content={"Job Offer"}
        sx={{ backgroundColor: "#9C27B0", color: "#FFF" }}
        size="small"
      />
    );
  } else if (status === "job offer accepted") {
    return (
      <CustomChip
        color="default"
        content={"Job Offer Accepted"}
        sx={{ backgroundColor: "#2E7D32", color: "#FFF" }}
        size="small"
      />
    );
  } else if (status === "job offer declined") {
    return (
      <CustomChip
        color="default"
        content={"Job Offer Declined"}
        sx={{ backgroundColor: "#D32F2F", color: "#FFF" }}
        size="small"
      />
    );
  } else if (status === "hired") {
    return (
      <CustomChip
        color="default"
        content={"Hired"}
        sx={{ backgroundColor: "#1976D2", color: "#FFF" }}
        size="small"
      />
    );
  } else if (status === "matched") {
    return (
      <CustomChip
        color="default"
        content={"Reconcilied"}
        sx={{ backgroundColor: "#28a745", color: "#FFF" }}
        size="small"
      />
    );
  } else if (status === "unmatched") {
    return (
      <CustomChip
        color="default"
        content={"Not Found"}
        sx={{ backgroundColor: "error.main", color: "#FFF" }}
        size="small"
      />
    );
  } else if (status === "has_differences") {
    return (
      <CustomChip
        color="default"
        content={"Not Reconcilied"}
        sx={{ backgroundColor: "#ffc107", color: "#000" }}
        size="small"
      />
    );
  } else if (status === "not reviewed") {
    return <CustomChip color="error" content={"Not Reviewed"} size={size} />;
  } else if (status === "reviewed") {
    return <CustomChip color="success" content={"Reviewed"} size={size} />;
  } else if (status === "inprogress") {
    return <CustomChip color="info" content={"In-Progress"} size={size} />;
  } else if (status === "voided") {
    return <CustomChip color="error" content={"Voided"} size={size} />;
  } else if (status === "re-open") {
    return (
      <CustomChip
        color="warning"
        content={"Re-Open"}
        sx={{ color: "#000" }}
        size={size}
      />
    );
  } else if (status === "not-approved") {
    return (
      <CustomChip
        color="warning"
        content={"Not Approved"}
        sx={{ color: "#000" }}
        size={size}
      />
    );
  } else if (status === "approved") {
    return (
      <CustomChip
        color="success"
        content={"Approved"}
        sx={{ color: "#000" }}
        size={size}
      />
    );
  } else if (status === "not_signed") {
    return (
      <CustomChip
        color="error"
        content={"Not Signed"}
        sx={{ color: "#fff" }}
        size={size}
      />
    );
  } else if (status === "signed") {
    return (
      <CustomChip
        color="success"
        content={"Signed"}
        sx={{ color: "#fff" }}
        size={size}
      />
    );
  } else if (status === "success") {
    return (
      <CustomChip
        color="success"
        content={"Success"}
        sx={{ color: "#fff" }}
        size={size}
      />
    );
  }
  else if (status === "won") {
    return (
      <CustomChip
        color="success"
        content={"Won"}
        sx={{ color: "#fff" }}
        size={size}
      />
    );
  }


else if (status === "waiting for approval") {
  return (
    <CustomChip
      color="warning"
      content="Waiting for Approval"
      sx={{ color: "#000" }}
      size={size}
    />
  );
} else if (status === "quoted- waiting on customer") {
  return (
    <CustomChip
      color="info"
      content="Waiting on Customer"
      sx={{ color: "#fff" }}
      size={size}
    />
  );
} else if (status === "lost-no response") {
  return (
    <CustomChip
      color="error"
      content="Lost - No Response"
      sx={{ color: "#fff" }}
      size={size}
    />
  );
} else if (status === "lost-due to price") {
  return (
    <CustomChip
      color="error"
      content="Lost - Due to Price"
      sx={{ color: "#fff" }}
      size={size}
    />
  );
}

else if (status === "quote submitted") {
  return (
   <CustomChip
      color="warning"
      content="Quote Submitted"
      sx={{ color: "#000" }}
      size={size}
    />
  );
}

else if (status === "opportunity") {
  return (
   <CustomChip
      color="success"
      content="Opportunity"
      sx={{ color: "#000" }}
      size={size}
    />
  );
}

else if (status === "cleared") {
  return (
    <CustomChip
      color="success"
      content="Cleared"
      sx={{ color: "#fff" }}
      size={size}
    />
  );
}

  else if (status === "failed") {
    return <CustomChip color="error" content={"Failed"} size={size} />;
  } 
  else if(status === "submitted"){
    return (
      <CustomChip
        color="warning"
        content={"Submitted"}
        sx={{ color: "#000" }}
        size={size}
      />
    );
  }
   else if (status === "deleted") {
    return <CustomChip color="error" content={"Deleted"} size={size} />;
  }
  else if (status === "quoted") {
    return (
      <CustomChip
        color="info"
        content={"Quoted"}
        sx={{ color: "#fff" }}
        size={size}
      />
    );
  } else if (status === "declined") {
    return (
      <CustomChip
        color="error"
        content={"Declined"}
        sx={{ color: "#fff" }}
        size={size}
      />
    );
  } else if (status === "closed-won") {
    return (
      <CustomChip
        color="success"
        content={"Closed-Won"}
        sx={{ color: "#fff" }}
        size={size}
      />
    );
  } else if (status === "closed-lost") {
    return (
      <CustomChip
        color="default"
        content={"Closed-Lost"}
        sx={{ backgroundColor: "#616161", color: "#fff" }}
        size={size}
      />
    );
  } else if (status === "more info needed") {
    return (
      <CustomChip
        color="secondary"
        content={"More Info Needed"}
        sx={{ color: "#fff" }}
        size={size}
      />
    );
  }
  
  
  else {
    return (
      <CustomChip
        color="info"
        content={capitalizeWords(status) || "N/A"}
        size={size}
      />
    );
  }
};

export const ReconsilationStatusRenderer: React.FC<
  IActiveInActiveStatusProps
> = (props) => {
  const status = (props.status || "").toLowerCase();
  const size = props.size || "small";
  if (status === "active") {
    return <CustomChip color="success" content={"Open"} size={size} />;
  } else if (status === "inactive") {
    return <CustomChip color="error" content={"Closed"} size={size} />;
  }
  return (
    <>
      <CustomChip
        color="warning"
        content={capitalizeWords(status) || "N/A"}
        size={size}
      />
    </>
  );
};
